module.exports = __webpack_public_path__ + "media/src/assets/images/home-banner@2x-695e793e14ffcec43b452811d6310090.png";